export default __webpack_public_path__ + "static/media/land_dark.b57e1221.png";